import { ITillConfig } from "../../models/till/ITillConfig";
import { ITillQuote } from "../../models/till/ITillQuote";
import { toPence } from "./changeDue";

/** Anything above this on a single cash sale is almost certainly a typo. */
export const MAX_CASH_TENDER = 10000;

export type CashTenderProblem = "invalid" | "belowTotal" | "aboveMax";
export type CardTenderProblem = "stripeDisabled" | "noReader" | "readerOffline";

export type TenderCheck<TProblem extends string> = { ok: true } | { ok: false; reason: TProblem };

export function validateCashTender(total: number, tendered: number): TenderCheck<CashTenderProblem> {
  if (!Number.isFinite(tendered) || tendered < 0) return { ok: false, reason: "invalid" };
  if (tendered > MAX_CASH_TENDER) return { ok: false, reason: "aboveMax" };
  if (toPence(tendered) < toPence(total)) return { ok: false, reason: "belowTotal" };
  return { ok: true };
}

/** Cash is on unless the till config says otherwise; the server enforces the same setting. */
export function isCashEnabled(config: ITillConfig | undefined): boolean {
  return config?.cashEnabled !== false;
}

export function validateCardTender(config: ITillConfig | undefined, readerId: string | null | undefined): TenderCheck<CardTenderProblem> {
  if (!config?.stripeEnabled) return { ok: false, reason: "stripeDisabled" };
  if (!readerId) return { ok: false, reason: "noReader" };

  const reader = config.readers.find((r) => r.id === readerId);
  if (!reader || reader.status !== "online") return { ok: false, reason: "readerOffline" };

  return { ok: true };
}

/** A basket can be tendered once it has at least one part and something to pay. */
export function isTenderable(quote: ITillQuote | undefined): boolean {
  if (!quote) return false;
  return quote.lines.some((l) => l.kind === "Part") && quote.totalPence > 0;
}
